import { Grid, GridProps } from "@mui/material";

export default (props: GridProps) => {
	return <Grid {...props} />;
};
